/**
 * 비상대응매뉴얼 기본정보(EMR_BASIC) 컬럼 정의
 * EMR_BASIC 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import { Checkbox } from '../../../../Components/MUIs';

/**
 * 비상대응매뉴얼 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 사업장코드 컬럼 (숨김)
    CreateColumn(
      'custCd',
      '사업장코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    // 파일명 컬럼
    CreateColumn(
      'fileName',
      '파일명',
      'left',
      100,
      false,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 작성일 컬럼
    CreateColumn('date', '등록일', 'center', 100, true, false, false, 'date', {
      minWidth: 100,
    }),
    // 앱 공유 (사업장당 1건만 체크, 앱 게시-비상대응매뉴얼 노출)
    CreateColumn(
      'appShareYn',
      '앱 공유',
      'center',
      100,
      false,
      false,
      false,
      'custom',
      {
        minWidth: 100,
        maxWidth: 110,
        flex: 0,
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        cellRenderer: (params) => (
          <Checkbox
            name=""
            checked={params.value === 'Y'}
            onChange={(change) => {
              const nextValue = change ? 'Y' : 'N';
              params.setValue(nextValue);
              if (nextValue === 'Y') {
                props.ClearOtherAppShareLogic?.(params.data?.no);
              }
            }}
            nameSx={{ m: 0 }}
          />
        ),
      }
    ),
    // 파일 다운로드 컬럼
    CreateColumn(
      'download',
      '파일 다운로드',
      'center',
      140,
      false,
      false,
      false,
      'download',
      {
        pinned: 'right',
        downloadClickHandler: props.DownloadLogic2,
      }
    ),
    // 작성자 컬럼 (숨김)
    CreateColumn(
      'createId',
      '작성자',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    // 체번 컬럼 (숨김)
    CreateColumn('chaebun', '체번', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    // 파일 관련 숨김 컬럼들
    CreateColumn('mapBlob', '블롭', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    CreateColumn('mapFile', '파일', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    CreateColumn(
      'mapFileName',
      '파일명(사용자가 올린 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    CreateColumn(
      'saveName',
      '파일명(저장되는 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    CreateColumn(
      'previewFilePath',
      '미리보기 주소',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    CreateColumn(
      'filePath',
      '파일 경로',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
